import { Card, Icon } from "@/components/atoms";
import { BookingDetails } from "@/redux/slices/booking/types";
import { DetailField } from "../../../../common/DetailField";

interface DriverNotesCardProps {
  booking: BookingDetails;
}

export const DriverNotesCard = ({ booking }: DriverNotesCardProps) => {
  const { closeMeta } = booking;
  const driverNotes = closeMeta?.driverNotes;

  return (
    <Card className="p-2.5">
      <DetailField
        leading={<Icon name="NoteText" size="lg" className="text-neutral-dark-gray" />}
        label="Driver Notes"
        value={driverNotes ? driverNotes : "-"}
      />
    </Card>
  );
};
